import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex justify-center items-center flex-col">
      <div>
        <img src={logo} className="w-64" />
      </div>
      <h1 className="text-4xl pt-4">404 Page Not Found</h1>
      <button
        className={`bg-yellow text-black px-10 py-2 mt-8 mb-1 rounded-3xl hover:brightness-90`}
        onClick={() => navigate("/")}
      >
        Go Home
      </button>
    </div>
  );
};

export default NotFound;
